import { Select } from "antd";
import Label from "components/Common/Label/Label";
import SearchFilterDropdown, { OptionType } from "components/Common/SearchableDropdown/SearchFilterDropdown";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { removeAgencyParent, resetAgencyParent, setAgencyParent } from "store/slices/searcSlice";
import { RootState } from "store/store";

const SelectAll = {
    value: "select-all",
    label: "Select All"
};

const DeSelectAll = {
    value: "deselect-all",
    label: "Deselect All"
};


const ParentAgencySelect = ({ parsedAgencyData, industryChangeTrigger, onParentAgencyChange }: any) => {
    const agencyParent = useSelector((state: RootState) => state.search.agency_parents);
    const dispatch = useDispatch();

    // State to manage dynamic options (Select All / Deselect All)
    const [agencyOptions, setAgencyOptions] = useState<any[]>([]);

    useEffect(() => {
        // Check if all agencies are selected to update the dropdown options dynamically

        parsedAgencyData.sort((a: any, b: any) => (a.label || "").localeCompare(b.label || ""));

        const areAllSelected = agencyParent.length === parsedAgencyData.length;

        const options = [
            {
                label: areAllSelected ? "Deselect All" : "Select All",
                value: areAllSelected ? "Deselect All" : "Select All"
            },
            ...parsedAgencyData.map((agency: any) => ({
                label: agency.label,  // Assuming agency has a 'label' field
                value: agency.value,  // Assuming agency has a 'value' field
            }))
        ];

        setAgencyOptions(options);
    }, [agencyParent, parsedAgencyData]);

    const handleSelect = (value: any) => {
        onParentAgencyChange && onParentAgencyChange(onParentAgencyChange);

        if (value.includes("Select All")) {
            // Select all logic
            parsedAgencyData.forEach((agency: any) => {
                dispatch(setAgencyParent(agency.value));
            });
        } else if (value.includes("Deselect All")) {
            // Deselect all logic
            parsedAgencyData.forEach((agency: any) => {
                dispatch(removeAgencyParent(agency.value));
            });
        } else {
            // Handle individual agency selection
            const lastValue = value[value.length - 1];
            dispatch(setAgencyParent(lastValue));
        }
    };

    const handleDeselect = (value: any) => {
        dispatch(removeAgencyParent(value));
        onParentAgencyChange && onParentAgencyChange();
    };

    useEffect(() => {
        if (industryChangeTrigger != null) {
            dispatch(resetAgencyParent());
            onParentAgencyChange && onParentAgencyChange();
        }
    }, [parsedAgencyData]);

    return (
        <div className="w-full mb-5">
            <Label labelTitle="Select Agencies Parent Group" isHelpIconRequired={false} />
            <div className="mt-1.5 SelectProject-input">
                <SearchFilterDropdown
                    mode="multiple"
                    options={agencyOptions}
                    onChange={handleSelect}
                    defaultValue={agencyParent}
                    handleDeselect={handleDeselect}
                    placeholder="Select agencies parent group"
                />
            </div>
        </div>
    );
};

export default ParentAgencySelect;
